import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import GridContainer from '@/components/Grid/GridContainer';
import Card from '@/components/Card/Card';
import CardHeader from '@/components/Card/CardHeader';
import CardBody from '@/components/Card/CardBody';
import SmartPayables from '@/components/SmartPayables';

export default function SmartPayablesPage() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        height: '89vh',
        overflow: 'hidden',
        pt: 2,
        px: 2,
        pb: 4,
      }}>
      <GridContainer>
        <Card>
          <CardHeader color='primary'>
            <Typography
              variant='h6'
              sx={{ color: 'white', fontWeight: 500 }}
              component='h4'>
              {t('smartPayablesManagement.title')}
            </Typography>
          </CardHeader>
          <CardBody>
            <SmartPayables />
          </CardBody>
        </Card>
      </GridContainer>
    </Box>
  );
}
